import React, { useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const treningiOpcje = [
  "Solo EMS",
  "Para EMS",
  "Para Personalny",
  "Solo Personalny",
  "Hybryda",
];

const generateTimeOptions = () => {
  const options = [];
  for (let hour = 0; hour < 24; hour++) {
    for (let minute = 0; minute < 60; minute += 30) {
      const time = `${String(hour).padStart(2, "0")}:${String(minute).padStart(
        2,
        "0"
      )}`;
      options.push(time);
    }
  }
  return options;
};

const timeOptions = generateTimeOptions();

const EditTrenerzy = ({ trener, onClose, onUpdate }) => {
  const [imie, setImie] = useState(trener.imie);
  const [nazwisko, setNazwisko] = useState(trener.nazwisko);
  const [email, setEmail] = useState(trener.email);
  const [telefon, setTelefon] = useState(trener.telefon);
  const token = localStorage.getItem("token"); // Pobierz token z localStorage

  const [godzinyPracy, setGodzinyPracy] = useState(trener.godziny_pracy);
  const [typyTreningow, setTypyTreningow] = useState(
    trener.typy_treningow || []
  );
  const [error, setError] = useState("");

  const handleCheckboxChange = (trening) => {
    if (typyTreningow.includes(trening)) {
      setTypyTreningow(typyTreningow.filter((t) => t !== trening));
    } else {
      setTypyTreningow([...typyTreningow, trening]);
    }
  };

  const handleUpdate = async () => {
    if (!imie || !nazwisko || !email || !telefon) {
      setError("Wszystkie pola są wymagane.");
      return;
    }

    if (typyTreningow.length === 0) {
      setError("Wybierz przynajmniej jeden typ treningu.");
      return;
    }

    for (const godzina of godzinyPracy) {
      if (!godzina.godzina_start || !godzina.godzina_koniec) {
        setError("Wszystkie godziny pracy muszą być wypełnione.");
        return;
      }
    }

    const updatedTrenerzy = {
      imie,
      nazwisko,
      email,
      telefon,
      godziny_pracy: godzinyPracy,
      typy_treningow: typyTreningow,
    };

    try {
      await axios.post(
        `${BACKEND_URL}/api/trenerzy/updateTrenerzy/${trener._id}`,
        updatedTrenerzy,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Dodaj token do nagłówka
          },
        }
      );
      onUpdate(updatedTrenerzy);
      onClose();
    } catch (err) {
      console.error("Błąd podczas aktualizacji trenera:", err);
      setError("Nie udało się zaktualizować trenera.");
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div
        className="fixed inset-0 bg-black opacity-50"
        onClick={onClose}
      ></div>
      <div className="bg-white rounded-lg shadow-lg p-8 z-10 w-[480px] max-h-[80vh] overflow-y-auto">
        <h2 className="text-2xl font-bold mb-6">Edytuj Trenera</h2>
        {error && <p className="text-red-500">{error}</p>}

        <input
          type="text"
          placeholder="Imię"
          value={imie}
          onChange={(e) => setImie(e.target.value)}
          className="border border-gray-300 rounded-md p-2 w-full mb-4"
        />
        <input
          type="text"
          placeholder="Nazwisko"
          value={nazwisko}
          onChange={(e) => setNazwisko(e.target.value)}
          className="border border-gray-300 rounded-md p-2 w-full mb-4"
        />
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="border border-gray-300 rounded-md p-2 w-full mb-4"
        />
        <input
          type="tel"
          placeholder="Telefon"
          value={telefon}
          onChange={(e) => setTelefon(e.target.value)}
          className="border border-gray-300 rounded-md p-2 w-full mb-4"
        />

        <h3 className="text-lg font-semibold mb-2">Typy Treningów</h3>
        <div className="mb-4">
          {treningiOpcje.map((trening) => (
            <label key={trening} className="block">
              <input
                type="checkbox"
                checked={typyTreningow.includes(trening)}
                onChange={() => handleCheckboxChange(trening)}
                className="mr-2"
              />
              {trening}
            </label>
          ))}
        </div>

        <h3 className="text-lg font-semibold mb-2">Godziny Pracy</h3>
        {godzinyPracy.map((godzina, index) => (
          <div key={index} className="mb-4">
            <label className="block mb-1">{godzina.dzien}</label>
            <select
              value={godzina.godzina_start}
              onChange={(e) => {
                const newGodziny = [...godzinyPracy];
                newGodziny[index].godzina_start = e.target.value;
                setGodzinyPracy(newGodziny);
              }}
              className="border border-gray-300 rounded-md p-2 w-full mb-2"
            >
              <option value="">Wybierz godzinę startową</option>
              {timeOptions.map((time) => (
                <option key={time} value={time}>
                  {time}
                </option>
              ))}
            </select>
            <select
              value={godzina.godzina_koniec}
              onChange={(e) => {
                const newGodziny = [...godzinyPracy];
                newGodziny[index].godzina_koniec = e.target.value;
                setGodzinyPracy(newGodziny);
              }}
              className="border border-gray-300 rounded-md p-2 w-full mb-2"
            >
              <option value="">Wybierz godzinę końcową</option>
              {timeOptions.map((time) => (
                <option key={time} value={time}>
                  {time}
                </option>
              ))}
            </select>
          </div>
        ))}

        <div className="flex justify-end gap-3">
          <button
            onClick={handleUpdate}
            className="px-4 py-2 rounded-md text-white bg-blue-500 hover:bg-blue-600 transition-colors duration-200"
          >
            Zapisz Zmiany
          </button>
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-md text-gray-700 bg-gray-100 hover:bg-gray-200 transition-colors duration-200"
          >
            Anuluj
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditTrenerzy;
